@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.dropdownMenuContent {
  @include border-radius-r2;

  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 8px;
  background-color: var(--surface-default);
  border: 1px solid var(--border-soft);
  box-shadow: 0 6px 10px 4px rgba(0, 0, 0, 15%), 0 2px 3px 0 rgba(0, 0, 0, 30%);
  z-index: var(--z-index-modal);
  max-width: 208px;
}

.styledButton {
  @include border-radius-r2;
}

.styledRadixItem {
  &:hover {
    outline: none;
  }
}

.item {
  @include border-radius-r1;

  display: flex;
  flex-direction: column;
  padding: 6px 16px;
  cursor: pointer;

  &:last-child {
    margin-bottom: 12px;
  }

  [data-checkmark] {
    margin-top: 0;
    width: 20px;
    height: 20px;

    @include border-radius-full;

    border: 1px solid inherit;
  }

  [data-checkbox] {
    align-items: center;
  }

  [data-checkbox-label] {
    @include typography-v2-body-sm;

    align-items: center;
  }
}

.itemInvalid {
  [data-checkmark] {
    border: 1px solid var(--border-critical);
  }
}

.actionItem {
  display: flex;
  padding: 12px 16px;
  border-top: 1px solid var(--border-soft);
}

.applyButton {
  height: 28px;
  width: 100%;
}

.checkboxDescription {
  @include typography-v2-body-xs;

  color: var(--text-soft);
  margin-left: 28px;
}
